module.exports = __webpack_public_path__ + "img/118.9.259dcc7a.png";